export default __webpack_public_path__ + "static/media/we-wish.a284dc55.jpg";